import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppConstant } from '../common/app.constant';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnChanges {
  display: Boolean;
  @Input() data: any;
  @Input() showConfirmation: Boolean;
  @Input() showReason: Boolean;
  @Input() showRejectReason: Boolean;
  @Output() confirmationAccept: EventEmitter<any> = new EventEmitter();
  @Output() confirmationCancel: EventEmitter<String> = new EventEmitter();
  public reasonValue: String;

  ngOnChanges(): void {
    this.display = this.showConfirmation;
  }

  accept() {
    this.confirmationAccept.emit({ status: AppConstant.CONFIRMATION_ACCEPT, reasonValue: this.reasonValue });
  }

  cancel() {
    this.confirmationCancel.emit(AppConstant.CLOSE_CONFIRMATION);
  }
}
